export { BaseTable as Table } from './table';
export { Classes } from './styles';